export default "__VITE_ASSET__XKTuIcuW__"